<template>
  <v-card>
    <v-card-text class="mb-6">
      <v-row class="ma-2">
        <v-avatar
          class="mr-2"
          size="62"
        >
          <v-icon size="62">
            account_circle
          </v-icon>
        </v-avatar>
        <div class="d-flex flex-column">
          <span class="title grey--text text--darken-2">{{
            item.usuario.nome
          }}</span>
          <span class="subtitle-1 grey--text text--darken-1">{{
            item.papel
          }}</span>
        </div>
      </v-row>
      <v-row class="mx-2">
        <v-col>
          <strong>Responsabilidade {{ item.status }}:</strong>
          <span :style="{ backgroundColor: item.tituloBackgroundColor }">
            {{ item.titulo }}
          </span>
        </v-col>
      </v-row>
      <v-row class="mx-2">
        <v-col>
          <v-tooltip
            max-width="500"
            top
          >
            <template v-slot:activator="{ on }">
              <v-badge
                :color="item.dificuldadeBackgroundColor"
                :content="item.dificuldadeBackgroundColor ? '' : undefined"
                overlap
              >
                <template v-slot:badge>
                  <span
                    v-if="item.dificuldadeBackgroundColor"
                    class="black--text"
                  >!</span>
                </template>
                <v-chip
                  color="success white--text"
                  label
                  small
                  v-on="on"
                >
                  Dificuldade
                  {{ item.dificuldade.valor }}
                </v-chip>
              </v-badge>
            </template>
            <span>{{ item.dificuldade.descricao }}</span>
          </v-tooltip>
          <v-tooltip
            max-width="500"
            top
          >
            <template v-slot:activator="{ on }">
              <v-badge
                :color="item.impactoBackgroundColor"
                :content="item.impactoBackgroundColor ? '' : undefined"
                overlap
              >
                <template v-slot:badge>
                  <span
                    v-if="item.impactoBackgroundColor"
                    class="black--text"
                  >!</span>
                </template>
                <v-chip
                  :class="item.dificuldadeBackgroundColor ? 'ml-4' : 'ml-2'"
                  color="secondary white--text"
                  label
                  small
                  v-on="on"
                >
                  Impacto
                  {{ item.impacto.valor }}
                </v-chip>
              </v-badge>
            </template>
            <span>{{ item.impacto.descricao }}</span>
          </v-tooltip>
        </v-col>
        <v-spacer />
      </v-row>
      <v-row class="mx-2">
        <v-col>
          <strong
            :style="{
              backgroundColor: item.hasDiffCompetencias ? 'yellow' : '',
            }"
          >
            Competências Técnicas ({{ item.competencias.length }}):
          </strong>
          <v-chip
            v-for="competencia in item.competencias"
            :key="competencia.id"
            :color="competencia.unidades.length === 0 ? 'secondary' : 'grey'"
            class="ml-1 mb-1"
            small
            text-color="white"
          >
            {{ competencia.nome }}
          </v-chip>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'HistoricoResponsabilidadeItem',

  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
